import React, { useEffect } from 'react';
import { FaSlack } from 'react-icons/fa';

const OAUTH_ERROR_MESSAGES: Record<string, string> = {
  missing_state: 'Connection failed: the request was missing a required parameter. Please try again.',
  user_not_found: 'Connection failed: your account could not be verified. Please log out and try again.',
};

const ConnectSlackPage: React.FC = () => {
  const params = new URLSearchParams(window.location.search);
  const status = params.get('status');
  const errorCode = params.get('error');

  const errorMessage = errorCode ? (OAUTH_ERROR_MESSAGES[errorCode] ?? 'Connection failed. Please try again.') : null;

  useEffect(() => {
    if (status === 'connected') {
      if (window.opener) window.opener.postMessage({ type: 'slack-connected' }, '*');
      window.close();
    }
  }, [status]);

  return (
    <div className="min-h-screen bg-base-200 flex items-center justify-center p-4">
      <div className="card bg-base-100 shadow-xl w-full max-w-sm">
        <div className="card-body gap-4 items-center text-center">
          <FaSlack className="text-4xl text-[#4A154B]" />

          {status === 'connected' && !window.opener && (
            <>
              <h2 className="card-title font-display">Slack Connected</h2>
              <p className="text-sm opacity-70">Your Slack workspace has been connected. You can close this window.</p>
              <button className="btn btn-primary btn-sm" onClick={() => window.close()}>
                Close
              </button>
            </>
          )}

          {status === 'connected' && window.opener && (
            <>
              <h2 className="card-title font-display">Connecting…</h2>
              <span className="loading loading-spinner loading-md" />
            </>
          )}

          {errorMessage && (
            <>
              <h2 className="card-title font-display text-error">Slack Connection Error</h2>
              <div className="alert alert-error">
                <span className="text-sm">{errorMessage}</span>
              </div>
              <button className="btn btn-ghost btn-sm" onClick={() => window.close()}>
                Close
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConnectSlackPage;
